import React from 'react';
import { toast, ToastContainer, ToastOptions } from 'react-toastify';

export default function Toast() {
  return (
    <ToastContainer position={toast.POSITION.TOP_RIGHT} hideProgressBar={true} theme="colored" />
  );
}

Toast.success = (message: string, options?: ToastOptions<Record<string, unknown>>) => {
  toast.success(
    <div className="mx-2">{message}</div>,
    Object.assign(
      {
        bodyClassName: 'py-3'
      },
      options
    )
  );
};

Toast.error = (message: string, options?: ToastOptions) => {
  toast.error(
    <div className="mx-2">{message}</div>,
    Object.assign(
      {
        bodyClassName: 'py-3'
      },
      options
    )
  );
};
